<template>
  <div class="convite_box">
    <div class="top_content">
      <div class="top_box">
        <div class="left_img_box">
          <img
            :src="data.level_icon"
            alt=""
          >
          <span>?</span>
        </div>
        <div class="right_box">
          <div class="right_info flex-between">
            <div class="label">
              {{ $t("收藏品") }} <span>{{ data.valid_user_num }}</span>
            </div>
            <div class="btn_box flex-row">
              <div class="btn disable">
                {{ $t("接收") }}
              </div>
              <div
                class="btn primary"
                @click="jumpShare"
              >
                {{ $t("历史") }}
              </div>
            </div>
          </div>
          <div class="right_info flex-between">
            <div class="label">
              {{ $t("代理模式") }}
            </div>
            <div class="desc">
              {{ $t("无限级差（每日结算）") }}
            </div>
          </div>
        </div>
      </div>
      <div class="center_box">
        <div class="link_box">
          <div class="qrcod_box">
            <div class="qrcode_img_box">
              <img
                :src="data.qrcode"
                alt=""
              >
            </div>
            <div
              class="btn primary"
              @click="downloadBase64Image"
            >
              {{ $t("点击保存") }}
            </div>
          </div>
          <div class="right_link_box">
            <div class="flex-between">
              <div class="textcolor1">
                {{ $t("我的链接") }}
              </div>
              <div class="rechargeColor">
                {{ $t("改变") }}
              </div>
            </div>
            <div class="link flex-between">
              <div class="textcolor1">
                {{ data.invite_url }}
              </div>
              <div
                class="rechargeColor"
                @click="doCopy(data.invite_url)"
              >
                <i class="el-icon-copy-document copy" />
              </div>
            </div>
            <div class="textcolor1">
              {{ $t("直接报告") }} &nbsp; <span>{{ data.direct_user_num }}</span>
            </div>
            <div class="textcolor1 code">
              {{ $t("邀请码") }} &nbsp;<span class="textcolorf">{{ data.invite_code }}</span> &nbsp;
              <i
                class="el-icon-copy-document"
                @click="doCopy(data.invite_code)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="bottom_box">
        <!-- <div class="link_item">
          <div class="imgbox">
            <van-icon
              class="img"
              name="share-o"
            />
          </div>
          <div class="title textcolor1">
            Partilhar
          </div>
        </div> -->
        <div
          v-for="item in data.promotion"
          :key="item.title"
          class="link_item"
          @click="jumpUrl(item)"
        >
          <img
            :src="item.image"
            alt=""
          >
          <div class="title textcolor1">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>

    <div class="bx_list">
      <ul>
        <li
          v-for="(item, index) in boxList"
          :key="index"

          @click="addBoxList(item.num, item.is_get, item.money, index)"
        >
          <div class="bx_tp">
            <img
              v-if="item.is_get == 0"
              class=""
              src="../../../assets/images/betReward/1.png"
              alt=""
            >
            <img
              v-if="item.is_get == 1"
              src="../../../assets/images/betReward/3.png"
              alt=""
              class="shadow_box"
            >
            <img
              v-if="item.is_get == 2"
              class=""
              src="../../../assets/images/betReward/2.png"
              alt=""
            >
            <p>{{ item.condition }} {{ $t("人们") }}</p>
          </div>
          <div class="bx_txt">
            {{ item.money }}
          </div>
        </li>

        <div class="clear" />
      </ul>
    </div>
    <!-- <div class="bottom_title">
      Rede do Agente
    </div>
    <linkPicSvg /> -->
  </div>
</template>
<script>
import Fetch from '../../../utils/fetch'
import linkPicSvg from '../svg/linkPicSvg.vue'
import a1 from '../../../assets/images/agent/1.png'
import a2 from '../../../assets/images/agent/2.png'
import a3 from '../../../assets/images/agent/3.png'
import a4 from '../../../assets/images/agent/4.png'
import a5 from '../../../assets/images/agent/5.png'
import a6 from '../../../assets/images/agent/6.png'
export default {
  components: {
    linkPicSvg
  },
  data() {
    return {
      data: {},
      show: false,
      linkList: [
        {
          title: 'Facebook',
          icon: a1
        },
        {
          title: 'Telegram',
          icon: a2
        },
        {
          title: 'WhatsApp',
          icon: a3
        },
        {
          title: 'Instagram',
          icon: a4
        },
        {
          title: 'Kwai',
          icon: a5
        },
        {
          title: 'YouTuBe',
          icon: a6
        },
      ],
      boxList: []
    }
  },
  created() {
    this.getConviteInfo()
    this.getBoxList()
  },
  methods: {
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
        return 'IOS';
      } else if (userAgent.match(/Android/i)) {
        return 'Android';
      } else {
        return 'unknown';
      }
    },
    getConviteInfo() {
      Fetch('/agent/init', undefined, { method: 'get' }).then(res => {
        this.data = res.data
      })
    },
    jumpUrl(item) {
      window.location.href = this.getMobileOperatingSystem() === 'IOS' ? item.ios_url : item.android_url
    },
    getBoxList() {
      Fetch("/box/boxList").then((r) => {
        this.boxList = r.data.list;
      });
    },
    addBoxList(num, is_get, money, index) {
      if(this.data.is_receive_box === 1) return
      if (is_get != 1 || this.isFetching) return false;

      this.isFetching = true;

      Fetch("/box/receive", { num: num }).then((r) => {
        console.log(r);
        if (r.code == 1) {
          this.$message({
            title: "R$" + money,
            message: r.msg,
            type: "success",
          });
          this.boxList[index].is_get = 2;
        } else {
          this.$message({
            title: "R$" + money,
            message: r.msg,
            type: "error",
          });
        }

        this.isFetching = false;
      });
    },
    doCopy(val) {
      let _this = this;
      this.$copyText(String(val)).then(
        function (e) {
          _this.$toast({
            background: "#07c160",
            message: _this.$t("复制成功"),
          });
        },
        function (e) {
          // console.log(e);
        }
      );
    },
    jumpShare() {
      // this.$router.push('/share')
      this.$emit('custom-event', { show: true });
    },
    downloadBase64Image() {
      const link = document.createElement('a');
      link.href = this.data.qrcode;
      link.download = 'Código2D.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.doCopy(this.data.invite_url)
    }
  }
}
</script>
<style lang="less">
@import '../../../assets/css/variables.less';

/deep/ .van-popup--top {
  top: 10%
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-row {
  display: flex;
}

.convite_box {
  padding: 0.24rem;
  height: 100%;
  overflow-y: auto;

  .top_content {
    background: @secondary-color;
    border-radius: 8px;

    .top_box {
      display: flex;
      padding-right: 0.4rem;
      border-bottom: 1px solid @bodercolor;
    }

    .left_img_box {
      display: flex;
      padding: 0 0.2rem 0 0.4rem;
      align-self: baseline;
      position: relative;

      img {
        width: 1.75rem;
      }

      span {
        position: absolute;
        display: inline-block;
        width: 0.32rem;
        height: 0.32rem;
        line-height: 0.32rem;
        text-align: center;
        background-color: @rechargeColor;
        color: @primary-color;
        border-radius: 50%;
        font-size: 0.26rem;
        margin-top: 0.1rem;
        right: 0.15rem;
      }
    }

    .right_box {
      flex: 1;
      padding: 0.24rem 0 0;

      .right_info {
        margin-bottom: 0.24rem;

        .desc {
          color: @textcolorf;
          font-size: 0.28rem;
        }
      }

      .btn_box {
        .btn {
          padding: 0.18rem 0.28rem;
          border-radius: .2rem;
          font-size: 0.28rem;
          margin-left: 0.24rem;

          &.disable {
            opacity: 0.7;
            background-color: @disableColor;
            color: @textcolorf;
          }

          &.primary {
            background-color: @rechargeColor;
            color: @textcolor6;
          }
        }
      }
    }

    .label {
      color: @textcolor2;
      font-size: 0.28rem;

      span {
        color: @rechargeColor;
        margin-left: 0.1rem;
      }
    }

    .center_box {
      padding: 0.24rem 0.24rem 0;

      .link {
        margin-top: 0.2rem;
        margin-bottom: 0.32rem;
        padding: 0.2rem 0.3rem;
        border-radius: 0.2rem;
        border: 1px solid @bodercolor;
      }

      .copy {
        font-size: 0.5rem;
      }

      .code {
        margin-top: 0.2rem;
        padding-bottom: 0.2rem;
      }

      .link_box {
        display: flex;

        .right_link_box {
          flex: 1;
          margin-left: 10px;
        }

        .qrcod_box {
          width: 68px;
          box-sizing: border-box;

          .qrcode_img_box {
            width: 100%;
            height: 68px;
            border: 1px solid @bodercolor2;
            padding: 2px;
            border-radius: 4px 4px 0 0;
          }

          img {
            width: 100%;
            height: 100%;
            border-radius: 4px 4px 0 0;
            display: block;
          }

          .btn {
            width: 100%;
            font-size: 12px;
            text-align: center;
            padding: 2px;
            border-radius: 0 0 4px 4px;

            &.primary {
              background-color: @rechargeColor;
              color: @textcolor6;
            }
          }
        }
      }
    }

    .bottom_box {
      display: flex;
      align-items: center;
      padding: 0.24rem;
      overflow-x: auto;

      .link_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 0.3rem;
        font-size: 0.3rem;

        img {
          width: 1rem;
          height: 1rem;
          margin-bottom: 0.12rem;
          border-radius: 50%;
        }

        .imgbox {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 0.94rem;
          height: 0.94rem;
          border-radius: 50%;
          font-size: 0.6rem;
          color: @rechargeColor;
          margin-bottom: 0.12rem;
          border: 1px solid @bodercolor;
        }
      }
    }
  }

  .bottom_title {
    font-size: 0.42rem;
    color: @textcolorf;
    margin: 16px 0;
  }
}

.bx_list {
  width: 100%;
  margin: 0 auto 30px;
  color: #fff;
  padding: 0.2rem 0.3rem 0.3rem 0.3rem;
  border-radius: 0.2rem;
  background-color: @secondary-color;
  font-size: 0.3rem;
  box-sizing: border-box;
  margin-top: 0.2rem;

  ul {
    display: flex;
    flex-wrap: wrap;
  }
}

.shadow_box {
  background: transparent;
  box-shadow: #765400 0px 0.3rem 0.5rem 0.1rem;
}

.bx_list li {
  width: 25%;
  text-align: center;
  padding-bottom: 0.6rem;
  position: relative;

  .bx_tp img {
    width: 1.7rem;
    left: 10%;
  }

  .bx_tp p {
    margin-top: -0.48rem;
    color: #fff;
    font-size: 0.28rem;
  }

  .bx_txt {
    font-size: 0.28rem;
  }
}

.rechargeColor {
  color: @rechargeColor;
}

.textcolor1 {
  color: @textcolor2;

  span {
    color: @textcolor1;
  }
}

.textcolorf {
  color: @textcolorf;
}
</style>